import { useEffect, useMemo, useState } from 'react';

/** Small client-side pagination for panel tables that are already loaded. */
export function usePagination<T>(rows: T[], pageSize = 12) {
  const [page, setPage] = useState(1);
  const total = rows.length;
  const pageCount = Math.max(1, Math.ceil(total / pageSize));
  useEffect(() => {
    setPage((current) => Math.min(current, pageCount));
  }, [pageCount]);
  const pageRows = useMemo(() => {
    const start = (Math.min(page, pageCount) - 1) * pageSize;
    return rows.slice(start, start + pageSize);
  }, [page, pageCount, pageSize, rows]);
  return { page: Math.min(page, pageCount), setPage, pageRows, total, pageSize };
}
